import {mapGetters} from 'vuex';
import store from '../store';
import {AIRPORT_NAME_GETTER, FLIGHTS_NAMESPACE} from '../store/modules/flights';
import api from '../api/flights';

/**
 * Flight service
 */
export default {
    /**
     * Vuex store instance
     *
     * @var {Object}
     */
    $store: store,
    /**
     * Flights getters from vuex storage
     */
    ...mapGetters(FLIGHTS_NAMESPACE, [
        AIRPORT_NAME_GETTER
    ]),
    /**
     * Get formatted location
     *
     * @param {Object} location
     *
     * @return {string}
     */
    getFormattedLocation(location) {
        return `${location.name} (${location.code})`;
    },
    /**
     * Get formatted location by iata code
     *
     * @param {string} code
     *
     * @return {string}
     */
    getFormattedLocationByCode(code) {
        const name = this[AIRPORT_NAME_GETTER]()(code);
        return code === name ? code : this.getFormattedLocation({code, name});
    },
    /**
     * Get locations details by query
     *
     * @param {string} query
     *
     * @return {Array}
     */
    async getLocations(query) {
        const locations = await api.getLocations(query);
        return locations.map(location => {
            location.value = this.getFormattedLocation(location);
            return location;
        });
    }
};